
import { mapMutations } from "vuex";
import contentMixins from "@/mixins/contentMixins";
import dateMixin from "@/mixins/dateMixins";
import Article from "@/graphql/article";
import ArticleTranslateUrl from "@/graphql/articleTranslateUrl";

export default {
  mixins: [contentMixins, dateMixin],
  name: "Article",
  nuxtI18n: {
    paths: {
      "en-ca": "/news/:slug",
      "fr-ca": "/actualites/:slug",
    },
  },
  async asyncData({ app, params, i18n, store }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();

    const newsResponse = await client.query({
      query: Article,
      variables: {
        slug: params.slug,
        locale: locale,
      },
    });

    const actualites = newsResponse.data.actualites.data;

    if (
      actualites[0].attributes.localizations.data?.length > 0 &&
      actualites[0].attributes.localizations.data[0]?.id
    ) {
      const getTranslateUrl = await client.query({
        query: ArticleTranslateUrl,
        variables: {
          id: actualites[0].attributes.localizations.data[0].id,
          locale:
            actualites[0].attributes.localizations.data[0].attributes.locale,
        },
      });

      if (
        getTranslateUrl?.data?.actualites?.data?.length > 0 &&
        getTranslateUrl?.data?.actualites.data[0]?.attributes.Slug
      ) {
        const translateUrl = getTranslateUrl.data.actualites.data[0].attributes;
        store.dispatch(
          "setTranslateUrl",
          `${
            translateUrl.locale === "fr-CA" ? "/actualites/" : "/en-ca/news/"
          }${translateUrl.Slug}`
        );
      } else {
        store.dispatch("setTranslateUrl", null);
      }
    }
    return { actualite: actualites[0].attributes };
  },
  data() {
    return {
      show: false,
    };
  },
  head() {
    return {
      title: this.actualite?.SEO?.MetaTitle && this.actualite?.SEO?.MetaTitle !== ""
              ? this.actualite.SEO.MetaTitle
              : this.$t('news.metaTitle'),
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.actualite?.SEO?.MetaDescription && this.actualite?.SEO?.MetaDescription != ""
              ? this.actualite.SEO.MetaDescription
              : this.$t('news.metaDesc'),
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.actualite.SEO.MetaDescription,
        },
        {
          hid: "og:image",
          name: "og:image",
          content:
            this.actualite.Image.data != null
              ? this.actualite.Image.data.attributes.url
              : "/og-image.jpg",
        },
      ],
      base: {
        target: "_blank",
      },
    };
  },

  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
      setTranslateUrl: "SET_TRANSLATE_URL",
    }),
  },
};
